/**
 * Layout de la sección WhatsApp oficial: encabezado con el comercio, avisos y la página.
 *
 * Las secciones (Resumen, Plantillas, Campañas…) ya no son pestañas acá arriba: desde el 07/10/2026 están en el
 * menú lateral, debajo de «WhatsApp» (`components/SeccionesOficial.ts`, que lee `Sidebar`).
 *
 * Todo va adentro de `CuentaOficialProvider`: todas las páginas leen de ahí el modo (simulado o Twilio) y la
 * config. En la app el proveedor ya viene de `DashboardLayout` (lo comparte con el menú) y este no arma otro; ese
 * proveedor vuelve a pedir la cuenta cada vez que se entra a la sección, como cuando vivía acá (`ProveedorCuenta`).
 *
 * La marca se elige sólo en el menú lateral (auditoría de diseño del 18/10/2026): acá había un segundo `SelectorMarca`, el
 * mismo componente y el mismo estado (`activaApi.marcaActual()`; cambiar en cualquiera de los dos recarga la página
 * entera), así que eran dos controles para una sola cosa. En el celular, la marca va en la barra de arriba
 * (`DashboardLayout`).
 *
 * En Conversaciones, desde `xl`, la página mide EXACTAMENTE la pantalla y la bandeja se queda con lo que dejan el
 * encabezado y los avisos (`flex-1` en `ConversacionesLayout`): la lista y la conversación tienen su
 * propio scroll y la caja para contestar queda siempre abajo, a la vista. Con un alto calculado a mano
 * (`calc(100vh - 22rem)` en el hilo) la columna medía más que la pantalla y la caja quedaba en y≈1023 a 1440x900.
 * Ahí los márgenes se achican: a 1280x720, lo de arriba de la bandeja se comía 234 px de los 720.
 */

import { Outlet, useMatch } from "react-router-dom";
import { CuentaOficialProvider } from "../contexto";
import { BannersOficial, ChipModoSimulado } from "../components/BannersOficial";

export default function OficialLayout() {
  const bandeja = !!useMatch("/activa/oficial/conversaciones/*");
  return (
    <CuentaOficialProvider>
      <div className={`min-h-screen p-6 md:p-8 animate-fade-in ${bandeja ? "xl:h-screen xl:py-5" : ""}`}>
        <div className={`mx-auto max-w-6xl space-y-5 ${bandeja ? "xl:flex xl:h-full xl:flex-col xl:space-y-4" : ""}`}>
          {/* Una fila chica de contexto: la sección y si es de prueba (la marca está en el menú). El título grande es el
              de cada página (Campañas, Plantillas…): antes arriba de todo iba «WhatsApp oficial» con una descripción
              técnica («la API oficial (Twilio)») en TODAS las pantallas, y el contenido arrancaba a mitad de la pantalla. */}
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700">WhatsApp oficial</h1>
            <ChipModoSimulado />
          </div>
          <BannersOficial />
          <Outlet />
        </div>
      </div>
    </CuentaOficialProvider>
  );
}
